import React from "react";
import Picture, { type ImgSet } from "./Picture";
import { galleryImgSet } from "../lib/mainImages";

export type GalleryItem =
  | { file: string; alt: string }
  | { id: string; image: ImgSet; alt: string; caption?: string };

interface GalleryProps {
  items: GalleryItem[];
  className?: string;
  testId?: string;
}

const Gallery: React.FC<GalleryProps> = ({ items, className = "gallery", testId }) => (
  <div className={className} data-testid={testId}>
    {items.map((it) => {
      if ("image" in it) {
        return (
          <figure className={`gallery-item${it.caption ? " gallery-item-captioned" : ""}`} key={it.id}>
            <Picture
              src={it.image}
              alt={it.alt}
              width={1200}
              height={900}
              sizes="(max-width: 600px) 50vw, (max-width: 1024px) 33vw, 25vw"
              responsiveVariantByViewport
            />
            {it.caption && <figcaption className="project-photo-caption">{it.caption}</figcaption>}
          </figure>
        );
      }
      const g = galleryImgSet(it.file);
      return (
        <figure className="gallery-item" key={it.file}>
          <Picture
            src={g.imgSet}
            alt={it.alt}
            width={g.displayWidth}
            height={g.displayHeight}
            srcWidths={g.srcWidths}
            sizes="(max-width: 600px) 50vw, (max-width: 1024px) 33vw, 25vw"
          />
        </figure>
      );
    })}
  </div>
);

export default Gallery;
